import {gql} from "@apollo/client";

export const GET_COORDINATORS_LIST = gql`
    query getCoordinatorsList {
        getCoordinatorsList {
            _id
            email
            profile {
                firstName
                lastName
            }
        }
    }
`;

export const ADD_COORDINATOR = gql`
    mutation addCoordinator($coordinatorInput: CoordinatorInput!) {
        addCoordinator(coordinatorInput: $coordinatorInput)
    }
`;
